import LoadingLogo from "../../../assets/images/LoadingLogo.png";
import classes from "./Loading.css";
const Loading = () => {
  return <img className={classes.Loading} alt="Loading" src={LoadingLogo} />;
};

export default Loading;
